var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-editor',{attrs:{"id":"editor1","editorToolbar":_vm.customToolbar,"useCustomImageHandler":""},on:{"image-added":_vm.handleImageAdded},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})}
var staticRenderFns = []

export { render, staticRenderFns }